module.exports = __webpack_public_path__ + "braveuistatic/img/apps/www.bravenet.com/src/assets/img/mailinglists/bravenet_mailinglists_responsive_emails.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.bravenet.com/src/assets/img/mailinglists/bravenet_mailinglists_responsive_emails.png
// module id = FO1V
// module chunks = 0